;(function () {
  const SESSION_KEY = "tb-sign-in-prompt-dismissed"

  function readConfig() {
    const el = document.getElementById("SignInPromptConfig")
    if (!el || !el.textContent.trim()) return null
    try {
      return JSON.parse(el.textContent)
    } catch {
      return null
    }
  }

  function isAuthAccountLandingPath(pathname) {
    const p = (pathname || "").split("?")[0].replace(/\/+$/, "") || "/"
    return /(^|\/)account\/login$/.test(p) || /(^|\/)account\/register$/.test(p)
  }

  function pathExcluded(path, raw) {
    if (!raw || typeof raw !== "string") return false
    const normalizedPath = (path || "").replace(/\/+$/, "") || "/"
    const pathVariants = [normalizedPath]
    const localePathMatch = normalizedPath.match(
      /^\/([a-z]{2}(?:-[a-z]{2})?)(\/.*)?$/i,
    )
    if (localePathMatch) {
      pathVariants.push(localePathMatch[2] || "/")
    }

    const lines = raw
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter(Boolean)
    for (const exclusionPath of lines) {
      const prefix = exclusionPath.replace(/\/+$/, "") || "/"
      for (const candidatePath of pathVariants) {
        if (candidatePath === prefix) return true
        if (prefix !== "/" && candidatePath.startsWith(prefix + "/"))
          return true
      }
    }
    return false
  }

  function init() {
    const modal = document.getElementById("SignInPromptModal")
    const accountLink = document.getElementById("HeaderAccountIcon")
    if (!modal || !accountLink) return
    if (modal.dataset.signInPromptInitialized === "true") return
    modal.dataset.signInPromptInitialized = "true"

    const cfg = readConfig() || {}
    const storageKey = cfg.sessionStorageKey || SESSION_KEY
    const rawExclusions = cfg.excludedPathPrefixesRaw || ""
    const suppressAuthPages =
      cfg.suppressAutoshowOnAuthPages === true ||
      isAuthAccountLandingPath(window.location.pathname)

    if (pathExcluded(window.location.pathname, rawExclusions)) {
      modal.remove()
      document.getElementById("SignInPromptConfig")?.remove()
      accountLink.classList.remove("header__icon--account-prompt")
      return
    }

    function isDismissedNow() {
      try {
        return sessionStorage.getItem(storageKey) === "1"
      } catch {
        return false
      }
    }

    function persistDismissal() {
      try {
        sessionStorage.setItem(storageKey, "1")
      } catch {
        /* ignore */
      }
    }

    function showModal(opener) {
      modal.openedBy = opener
      modal.setAttribute("open", "")
      modal.setAttribute("aria-hidden", "false")
    }

    function hideModal(restoreFocus) {
      modal.removeAttribute("open")
      modal.setAttribute("aria-hidden", "true")
      if (restoreFocus && modal.openedBy) {
        modal.openedBy.focus()
      }
    }

    function dismissModal() {
      persistDismissal()
      hideModal(true)
    }

    const desktopMq = window.matchMedia(
      `(min-width: ${typeof cfg.desktopMinWidth === "number" ? cfg.desktopMinWidth : parseInt(cfg.desktopMinWidth || "1200", 10) || 1200}px)`,
    )

    function applyViewportModalDefault() {
      if (isDismissedNow() || suppressAuthPages) {
        hideModal(false)
        return
      }
      const accountEl =
        modal.openedBy ||
        document.getElementById("HeaderAccountIcon") ||
        accountLink
      if (desktopMq.matches) {
        modal.openedBy = accountEl || accountLink
        modal.setAttribute("open", "")
        modal.setAttribute("aria-hidden", "false")
      } else {
        hideModal(false)
      }
    }

    modal.show = showModal
    modal.hide = function wrappedHide() {
      dismissModal()
    }

    function openModal(opener) {
      modal.show(opener || accountLink)
    }

    document.addEventListener(
      "click",
      (e) => {
        if (e.target.closest("#ModalClose-sign-in-prompt")) {
          e.preventDefault()
          e.stopPropagation()
          dismissModal()
          return
        }

        if (!modal.hasAttribute("open")) return
        if (e.target.closest("#SignInPromptModal")) return
        if (e.target.closest("#HeaderAccountIcon")) return

        dismissModal()
      },
      true,
    )

    document.addEventListener("keyup", (e) => {
      if (e.key !== "Escape") return
      if (!modal.hasAttribute("open")) return
      dismissModal()
    })

    accountLink.addEventListener("click", (e) => {
      if (accountLink.getAttribute("data-customer-logged-in") === "true") {
        return
      }
      if (isAuthAccountLandingPath(window.location.pathname)) {
        return
      }
      e.preventDefault()
      openModal(accountLink)
    })

    const onDesktopMqChange = () => applyViewportModalDefault()
    if (typeof desktopMq.addEventListener === "function") {
      desktopMq.addEventListener("change", onDesktopMqChange)
    } else if (typeof desktopMq.addListener === "function") {
      desktopMq.addListener(onDesktopMqChange)
    }

    applyViewportModalDefault()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()
